import React from 'react';

type Props = {
  horizontals?: number;
  verticals?: number;
  spacing?: number;
};

const MeshLines: React.FC<Props> = ({ horizontals = 6, verticals = 24, spacing = 8 }) => (
  <span className="btn-mesh" aria-hidden="true">
    {Array.from({ length: horizontals }).map((_, i) => (
      <span
        key={`h${i}`}
        className="btn-mesh-h"
        style={{ top: `${(i + 1) * spacing}px`, transitionDelay: `${30 + i * 30}ms` }}
      />
    ))}
    {Array.from({ length: verticals }).map((_, i) => (
      <span
        key={`v${i}`}
        className="btn-mesh-v"
        style={{ insetInlineStart: `${(i + 1) * spacing}px`, transitionDelay: `${220 + i * 20}ms` }}
      />
    ))}
  </span>
);

export default MeshLines;
